import React, { useState } from 'react'
 
 
import WorkServiceInvoiceList from './WorkServiceInvoiceList';
import WorkServiceInvoiceForm from './WorkServiceInvoiceForm';

const WorkServiceInvoice= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <WorkServiceInvoiceForm addForm={setFromIsShown} update={upData}    sId={serviceId} />
        ) : (
          <WorkServiceInvoiceList addForm={setFromIsShown} update={setUpData}     sId={setServiceId}/>
        )}  
    </>
  )
}

export default WorkServiceInvoice